import React, { useState, useEffect } from "react";
import { Signal, Wifi, BatteryFull } from "lucide-react";

export const StatusBar = () => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const update = () =>
      setTime(new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }));
    update();
    const t = setInterval(update, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="pt-3 px-5 pb-2 flex items-center justify-between text-xs font-semibold tracking-tight text-slate-700 dark:text-slate-300 bg-stone-50/90 dark:bg-emerald-950/90 backdrop-blur-md sticky top-0 z-40 border-b border-emerald-900/5 dark:border-emerald-800/40">
      <span data-testid="status-bar-time">{time}</span>
      <div className="flex items-center gap-1.5">
        <Signal className="w-3.5 h-3.5" />
        <Wifi className="w-3.5 h-3.5" />
        <BatteryFull className="w-4 h-4" />
      </div>
    </div>
  );
};
